define(["angular", "angular-animate", "angular-bootstrap", "../user/user"], function (angular) {
    "use strict";

    return angular.module("moveToAnotherUserModule",  ["ngAnimate", "ui.bootstrap", "commonsUserModule"]);
});